import React, { memo } from "react";
import Row from "./Row";
import { GridItem } from "./GridItem";
import Loader from "../../common/components/Loader";

export const RowList = memo(({ index, data, style }) => {
    const {
        columnCount,
        imageData,
        handleMultiSelectImage,
        selectedImages,
        handleEdit,
        handleFavClick,
        isAssignView,
        hasEdit,
        viewRecommendations,
        viewImageModal,
        showSelectBox,
        handleInputCaptionData,
        viewAssets,
        touchedImageId,
        isSmartChartView,
        isNextPageLoading,
        entityPluralLabel = "Recommendations",
        entityLabel = "Recommendation",
        imageBadges
    } = data;

    const startIndex = index * columnCount;
    const endIndex = Math.min(startIndex + columnCount, imageData.length);
    const itemsInRow = imageData.slice(startIndex, endIndex);

    if (isNextPageLoading && startIndex >= imageData.length) {
        return (
            <Row style={style}>
                <Loader />
            </Row>
        );
    }
    return (
        <Row style={style}>
            {itemsInRow.map((item, i) => (
                <GridItem
                    key={item.id}
                    index={startIndex + i}
                    handleMultiSelectImage={handleMultiSelectImage}
                    item={item}
                    isSelected={!!selectedImages.find(img => img.id === item.id)}
                    isSmartChartView={isSmartChartView}
                    handleEdit={handleEdit}
                    handleFavClick={handleFavClick}
                    isAssignView={isAssignView}
                    hasEdit={hasEdit}
                    viewRecommendations={viewRecommendations}
                    entityPluralLabel={entityPluralLabel}
                    entityLabel={entityLabel}
                    viewImageModal={viewImageModal}
                    showSelectBox={showSelectBox}
                    handleInputCaptionData={handleInputCaptionData}
                    viewAssets={viewAssets}
                    isTouched={touchedImageId === item.id}
                    badge={imageBadges ? imageBadges[item.id] : null}
                    isFavorite={item.favourite}
                    isEdited={item.is_edited}
                    updatedAt={item.updated_at}
                />
            ))}
        </Row>
    );
});
